import { useQuery } from "react-query";
import type { UseQueryOptions } from "react-query";
import type { Paywall } from "@/react/types/Paywall";
import { paywallApi } from "@circle-react/api/paywallApi";

export const paywallListQueryKey = "paywalls-list";

const paywallStatusDefault: string[] = [];

interface UsePaywallListParams {
  communityMemberId?: string | number | null;
  queryParams?: UseQueryOptions<Paywall[]>;
  spaceIds?: Array<string | number | undefined>;
  status?: string[];
}

interface UsePaywallListReturn {
  paywallsListQuery: ReturnType<typeof useQuery<Paywall[]>>;
}

export const usePaywallList = ({
  communityMemberId,
  status = paywallStatusDefault,
  queryParams = {},
  spaceIds = [],
}: UsePaywallListParams): UsePaywallListReturn => {
  const paywallsListQuery = useQuery<Paywall[]>(
    [paywallListQueryKey, communityMemberId, { status, spaceIds }],
    paywallApi.index({
      community_member_id: communityMemberId?.toString() ?? "",
      status: status.join(","),
      space_ids: spaceIds
        .filter(id => id != null)
        .map(id => String(id))
        .join(","),
    }),
    queryParams,
  );

  return {
    paywallsListQuery,
  };
};
